/**
 * StreamsCtrl controller
 * Show all devices
 */

import { SETRIX_INPUT_TYPES, SETRIX_INPUT_TYPES_LABELS, SETRIX_OUTPUT_URI_TYPES_LABELS, SETRIX_STREAM_WORK_STATUS_TYPES_LABELS, SETRIX_VIDEO_TYPES_LABELS } from 'app/core/constants'

/**
 * StreamsCtrl controller
 *
 * @class StreamsCtrl
 * @memberof mwApp/devices
 * @see mwApp/devices
 *
 * @ngdoc controller
 * @name mwApp/devices.controller:StreamsCtrl
 */
/* @ngInject */
export default function StreamsCtrl ($scope, $interval, Stream, alertSvc, alertLiteSvc) {
  var vm = this
  vm.isFound = true

  $scope.$on('$destroy', function () {
    $interval.cancel($scope.promise)
  })

  // start interval for refresh table
  $scope.promise = $interval(() => {
    $scope.$broadcast('refreshTable')
  }, 10000)

  /**
   * Timer for update
   *
   * @type {null}
   */
  $scope.$timer = null

  /**
   * Loader indicator
   *
   * @type {boolean}
   */
  $scope.loading = true

  /**
   * Devices list
   *
   * @memberof mwApp/devices.controller:StreamsCtrl
   */
  vm.streams = []

  /**
   * Status label constants
   *
   * @memberof mwApp/devices.controller:StreamsCtrl
   */
  vm.setrix_stream_work_status_types_labels = SETRIX_STREAM_WORK_STATUS_TYPES_LABELS

  /**
   * Video label constants
   *
   * @memberof mwApp/devices.controller:StreamsCtrl
   */
  vm.setrix_video_types_labels = SETRIX_VIDEO_TYPES_LABELS

  /**
   * Output uri types labels
   *
   * @memberof mwApp/devices.controller:StreamsCtrl
   */
  vm.setrix_output_uri_types_labels = SETRIX_OUTPUT_URI_TYPES_LABELS

  /**
   * Input types labels
   *
   * @memberof mwApp/devices.controller:StreamsCtrl
   */
  vm.setrix_input_types_labels = SETRIX_INPUT_TYPES_LABELS

  /**
   * Input types
   *
   * @memberof mwApp/devices.controller:StreamsCtrl
   */
  vm.setrix_input_types = SETRIX_INPUT_TYPES

  /**
   * Get Streams from backend
   *
   * @memberof mwApp/devices.controller:StreamsCtrl
   * @param {Object} tableState - smart table state object
   */
  vm.getStreams = function (tableState) {
    // set default sort by id
    if (!tableState.sort.predicate) {
      tableState.sort.predicate = 'name'
      tableState.sort.reverse = false
    }

    if (tableState.search.predicateObject) {
      if (Object.prototype.hasOwnProperty.call(tableState.search.predicateObject, 'streamType')) {
        tableState.search.predicateObject['stream-type'] = tableState.search.predicateObject.streamType
        delete tableState.search.predicateObject.streamType
      }

      if (Object.prototype.hasOwnProperty.call(tableState.search.predicateObject, 'workStatus')) {
        tableState.search.predicateObject['work-status'] = tableState.search.predicateObject.workStatus
        delete tableState.search.predicateObject.workStatus
      }
    }

    Stream.loadSmart(tableState)
      .then(
        data => {
          vm.streams = data.content
          vm.isFound = !!vm.streams.length
          $scope.loading = false
        }
      ).then(() => {
        if (tableState.search.predicateObject) {
          if (Object.prototype.hasOwnProperty.call(tableState.search.predicateObject, 'stream-type')) {
            tableState.search.predicateObject.streamType = tableState.search.predicateObject['stream-type']
            delete tableState.search.predicateObject['stream-type']
          }

          if (Object.prototype.hasOwnProperty.call(tableState.search.predicateObject, 'work-status')) {
            tableState.search.predicateObject.workStatus = tableState.search.predicateObject['work-status']
            delete tableState.search.predicateObject['work-status']
          }
        }
      })
  }

  /**
   * Handler success for ngclipboard
   *
   * @param e
   */
  vm.onCopySuccess = function (e) {
    alertLiteSvc.alert('Output uri <strong>' + e.text + '</strong> successfully copied!', 'success')
  }

  /**
   * Handler error for ngclipboard
   *
   * @param e
   */
  vm.onCopyError = function (e) {
    alertLiteSvc.alert('Copying error', 'danger')
  }

  /**
   * Check stream comment status
   *
   * @param comments
   * @return {string}
   */
  vm.worstStatus = function (comments) {
    if (comments) {
      if (comments.find(comment => comment.type === 'CRITICAL')) {
        return 'CRITICAL'
      }
      if (comments.find(comment => comment.type === 'WARNING')) {
        return 'WARNING'
      }
      if (comments.find(comment => comment.type === 'NOTICE')) {
        return 'NOTICE'
      }
    }
    return ''
  }

  /**
   * HTML comment generator
   *
   * @param comments
   * @return {string}
   */
  $scope.mapComments = function (comments) {
    if (comments) {
      return comments.reduce((prev, c) => {
        return prev + `<div class="comment">${c.type === 'NOTICE'
          ? '<i class="fa fa-info-circle text-info" aria-hidden="true"></i>'
          : c.type === 'WARNING'
            ? '<i class="fa fa-exclamation-triangle custom-text-warning" aria-hidden="true"></i>'
            : '<i class="fa fa-exclamation-circle text-danger" aria-hidden="true"></i>'} ${c.message} 
            </div>\n`
      }, ' ')
    }
    return ''
  }
}
